(() => {
  'use strict';
  if (window.MbgTbiAdapter) return;

  const SCRIPT_URL = 'https://beta.tbibank.support/fusion-pay-tbi/shopify/files/script-tbi-multimediabg.js';
  const BASKET_URL = 'https://beta.tbibank.support/api/RegisterBasket';
  const LOGO_URL = 'https://cdn.tbibank.support/logo/tbi-bank-white.svg';
  const ERRORS = {
    unavailable: 'Избраният вариант не е наличен. Изберете наличен вариант.',
    quantity: 'Проверете количеството на избраните продукти.',
    currency: 'Плащане с tbi bank е достъпно само в EUR.',
    limits: 'tbi bank предлага финансиране за суми между 50 EUR и 15000 EUR.',
    cart: 'Количката се обновява. Изчакайте и опитайте отново.',
    validation: 'Проверете данните и условията в количката преди да продължите.',
    totals: 'Отстъпката в количката не може да се изчисли за tbi bank. Използвайте стандартното плащане.',
    network: 'Връзката с tbi bank е временно недостъпна. Опитайте отново или използвайте стандартното плащане.',
    product: 'Не успяхме да заредим избрания вариант. Обновете страницата и опитайте отново.',
    addons: 'Добавете избраните продукти в количката и изберете tbi bank оттам.'
  };
  const sectionListeners = new Map();
  let vendorPromise;
  let vendorPatched = false;
  let popupInitialized = false;
  let refreshQueued = false;
  let applicationPending = false;
  let cartRevision = 0;
  let lastCartInteraction = 0;

  function readJson(element) {
    try { return JSON.parse(element?.textContent || 'null'); } catch (_) { return null; }
  }

  function config() { return readJson(document.getElementById('MbgTbiConfig')) || {}; }
  function rootUrl() { return window.Shopify?.routes?.root || config().productRoot || '/'; }
  function sleep(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }
  function fail(key) { throw new Error(ERRORS[key]); }
  function cents(value) { return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0; }
  function positiveInteger(value) { return Number.isSafeInteger(value) && value > 0; }

  function requireCurrency(currency) {
    if (currency !== 'EUR') fail('currency');
  }

  function requireTotal(total) {
    if (!cents(total) || total < 5000 || total > 1500000) fail('limits');
  }

  function imageUrl(image) {
    const value = typeof image === 'string' ? image : image?.src || image?.url || '';
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      return /^https?:$/.test(url.protocol) ? url.href : '';
    } catch (_) { return ''; }
  }

  function variantName(title, variantTitle) {
    return variantTitle && variantTitle !== 'Default Title' ? `${title} (${variantTitle})` : title;
  }

  function installationName(name, requested) {
    const note = config().installationRequestNote;
    return name && requested && typeof note === 'string' && note.trim() ? `${name} · ${note}` : name;
  }

  function cartItems(cart) {
    requireCurrency(cart.currency);
    if (!Array.isArray(cart.items) || !cart.items.length) fail('quantity');
    const finalSum = cart.items.reduce((sum, line) => sum + (cents(line.final_line_price) ? line.final_line_price : NaN), 0);
    const discountedSum = cart.items.reduce((sum, line) => sum + (cents(line.line_price) ? line.line_price : NaN), 0);
    const priceField = finalSum === cart.total_price ? 'final_line_price' : 'line_price';
    if (priceField === 'line_price' && (discountedSum !== cart.total_price || cart.items.some(line => line.line_price > line.final_line_price))) fail('totals');
    const items = [];
    let total = 0;
    cart.items.forEach(line => {
      if (!positiveInteger(line.quantity) || !cents(line.final_line_price)) fail('quantity');
      if (line.selling_plan_allocation) fail('validation');
      const lineTotal = line[priceField];
      const base = Math.floor(lineTotal / line.quantity);
      const remainder = lineTotal % line.quantity;
      const common = {
        name: installationName(line.product_title ? variantName(line.product_title, line.variant_title) : line.title, line.properties?._mbg_installation_requested === 'true'),
        imagelink: imageUrl(line.featured_image || line.image),
        category: 0
      };
      if (!common.name) fail('cart');
      if (line.quantity - remainder) items.push({ ...common, price: base / 100, qty: line.quantity - remainder });
      if (remainder) items.push({ ...common, price: (base + 1) / 100, qty: remainder });
      total += lineTotal;
    });
    if (!cents(cart.total_price) || total !== cart.total_price) fail('totals');
    requireTotal(total);
    return items;
  }

  function getMainProduct() {
    const data = readJson(document.getElementById('MbgTbiProductData'));
    const scope = document.querySelector('main-product[data-section-id]');
    const form = scope?.querySelector('.product-info__form-wrapper form[data-type="add-to-cart-form"]');
    return data && scope && form ? { data, scope, form, sectionId: scope.dataset.sectionId } : null;
  }

  function getSelection(form) {
    const input = Array.from(form.elements).find(element => element.name === 'id');
    const data = new FormData(form);
    const id = String(data.get('id') || '');
    if (!input || input.disabled || !/^\d+$/.test(id)) fail('unavailable');
    const quantity = data.has('quantity') ? Number(data.get('quantity')) : null;
    if (quantity !== null && !positiveInteger(quantity)) fail('quantity');
    if (data.get('selling_plan')) fail('validation');
    const installationRequested = form.querySelector('[data-mbg-installation-request]')?.checked === true;
    return { id, quantity, installationRequested };
  }

  function productBusy(form) {
    const button = form.querySelector('button[name="add"]');
    return !button || button.disabled || button.getAttribute('aria-disabled') === 'true' || button.classList.contains('is-loading');
  }

  function optionsMatch(scope, variant) {
    if (!Array.isArray(variant.options)) return true;
    return [...scope.querySelectorAll('variant-picker .variant-option.selected')].every(option => {
      const index = Number(option.dataset.optionPosition) - 1;
      return !Number.isInteger(index) || option.dataset.value === variant.options[index];
    });
  }

  function sameVariant(variant, id) {
    return variant && String(variant.id) === id && cents(variant.price) && typeof variant.available === 'boolean';
  }

  async function fetchJson(url) {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(12000) });
    if (!response.ok) fail('product');
    return response.json();
  }

  function localizedProductUrl(data) {
    const url = new URL(data.url, location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) fail('product');
    const productPath = url.pathname.slice(url.pathname.indexOf('/products/') + 1);
    url.pathname = `${rootUrl().replace(/\/?$/, '/')}${productPath}`;
    url.search = '';
    url.hash = '';
    return url;
  }

  async function resolveVariant(context, id) {
    const state = sectionListeners.get(context.sectionId);
    const candidates = [
      state?.variant,
      readJson(document.getElementById(`CurrentVariantInfo__${context.sectionId}`)),
      context.scope.querySelector('variant-picker')?.currentVariant,
      readJson(context.form.closest('.product-info__form-wrapper')?.querySelector('[data-type="init-current-variant"]')),
      context.data.selected_or_first_available_variant,
      ...(context.data.variants || [])
    ];
    const variant = candidates.find(candidate => sameVariant(candidate, id));
    if (variant) return variant;
    const url = localizedProductUrl(context.data);
    const product = await fetchJson(`${url.href}.js`);
    const fetched = product.variants?.find(candidate => sameVariant(candidate, id));
    if (fetched) return fetched;
    url.searchParams.set('variant', id);
    url.searchParams.set('section_id', context.sectionId);
    const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(12000) });
    if (!response.ok) fail('product');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const selected = readJson(html.getElementById(`CurrentVariantInfo__${context.sectionId}`)) || readJson(html.getElementById('MbgTbiProductData'))?.selected_or_first_available_variant;
    if (!sameVariant(selected, id)) fail('product');
    return selected;
  }

  async function productItems() {
    const context = getMainProduct();
    if (!context) fail('product');
    requireCurrency(context.data.currency || config().currency || window.Shopify?.currency?.active);
    if (productBusy(context.form)) fail('unavailable');
    if ([...document.querySelectorAll('.ppa-prod-container-grid .ppa-add-to-cart-btn')].some(button => button.textContent.trim() === 'Премахни')) fail('addons');
    if (!context.form.reportValidity()) fail('validation');
    const selection = getSelection(context.form);
    const variant = await resolveVariant(context, selection.id);
    const current = getSelection(context.form);
    if (!context.form.isConnected || current.id !== selection.id || current.quantity !== selection.quantity || current.installationRequested !== selection.installationRequested || productBusy(context.form) || !optionsMatch(context.scope, variant)) fail('product');
    if (!variant.available) fail('unavailable');
    const rule = variant.quantity_rule || {};
    const increment = positiveInteger(rule.increment) ? rule.increment : 1;
    const min = positiveInteger(rule.min) ? rule.min : 1;
    const quantity = selection.quantity ?? Math.ceil(min / increment) * increment;
    if (quantity < min || quantity % increment || (rule.max != null && quantity > rule.max)) fail('quantity');
    requireTotal(variant.price * quantity);
    return [{ name: installationName(variantName(context.data.title, variant.title), selection.installationRequested), price: variant.price / 100, qty: quantity, category: 0, imagelink: imageUrl(variant.featured_image || context.data.featured_image) }];
  }

  function cartScope(kind) {
    return document.querySelector(kind === 'drawer' ? '#CartDrawer' : '.section-main-cart') || (kind === 'cart' ? document.getElementById('MainCart__Summary')?.closest('.shopify-section') : null);
  }

  function cartHelper(kind) {
    try { return kind === 'drawer' ? window.xCartHelper : window.Alpine?.store('xCartHelper'); } catch (_) { return null; }
  }

  function nativeCartBusy() {
    if (window.xCartHelper?.isUpdating || document.getElementById('CartDrawer')?.isLoading) return true;
    if (document.querySelector('.cart-drawer__checkout[aria-disabled="true"], .main-cart__checkout-button[aria-disabled="true"]')) return true;
    try {
      if (window.Alpine?.store('xCartHelper')?.isUpdating) return true;
      const cart = document.querySelector('#MainCart__Items [x-data], [x-data^="xCart("]');
      if (cart && window.Alpine?.$data(cart)?.isLoading) return true;
    } catch (_) { /* A lazy cart component may not be initialized yet. */ }
    return [...document.querySelectorAll('[id^="CartItem__Loading__"]')].some(element => !element.classList.contains('hidden') && element.getClientRects().length);
  }

  async function waitForCart() {
    if (window.MBGCartGuard?.waitForIdle) {
      if (!await window.MBGCartGuard.waitForIdle()) fail('cart');
      return;
    }
    const started = Date.now();
    const quietTime = window.Maximize?.isB2BCustomer ? 2750 : 750;
    while (nativeCartBusy() || Date.now() - lastCartInteraction < quietTime) {
      if (Date.now() - started > 12000) fail('cart');
      await sleep(100);
    }
  }

  async function validateCart(kind) {
    const scope = cartScope(kind);
    if (!scope) fail('cart');
    if (window.MBGCartGuard?.validate) {
      if (!await window.MBGCartGuard.validate(kind === 'drawer' ? 'drawer' : 'page')) fail('validation');
      return;
    }
    const helper = cartHelper(kind);
    helper?.validateCart?.();
    await Promise.resolve();
    const agreement = scope.querySelector(kind === 'drawer' ? '#CartDrawer__Agree' : '#MainCart__Agree');
    const form = kind === 'drawer' ? document.getElementById('CartDrawerForm') : scope.querySelector('#main-cart');
    if (helper?.validated === false || (agreement && !agreement.checked) || (form && !form.reportValidity())) fail('validation');
    if (scope.querySelector('.cart__insufficent')) fail('quantity');
  }

  function quantitiesMatch(cart, kind) {
    const items = new Map(cart.items.map(item => [item.key, item.quantity]));
    return [...(cartScope(kind)?.querySelectorAll('.cart-item__wrapper[data-cart-item-key]') || [])].every(row => {
      const input = row.querySelector('input[type="number"]');
      return !input || (items.has(row.dataset.cartItemKey) && Number(input.value) === items.get(row.dataset.cartItemKey));
    });
  }

  async function currentCartItems(kind) {
    for (let attempt = 0; attempt < 3; attempt++) {
      await waitForCart();
      await validateCart(kind);
      const revision = cartRevision;
      const url = new URL(config().cartUrl || `${rootUrl()}cart.js`, location.origin);
      if (url.origin !== location.origin) fail('cart');
      const cart = await fetchJson(url.href);
      if (revision !== cartRevision || nativeCartBusy() || window.MBGCartGuard?.isPending()) continue;
      if (!quantitiesMatch(cart, kind)) fail('cart');
      return cartItems(cart);
    }
    fail('cart');
  }

  function showError(button, message) {
    const error = button.parentElement?.querySelector('.mbg-tbi-error');
    if (error) { error.textContent = message; error.hidden = !message; }
  }

  function patchVendor() {
    if (vendorPatched) return;
    if (typeof window.initializePopup !== 'function' || typeof window.postData !== 'function') fail('network');
    const initialize = window.initializePopup;
    popupInitialized = !!document.getElementById('tbiPopUpContainer');
    window.initializePopup = function () {
      if (popupInitialized) return;
      initialize();
      popupInitialized = true;
    };
    window.createProductButton = installProduct;
    window.createMiniCartButton = installCarts;
    vendorPatched = true;
    window.initializePopup();
    refresh();
  }

  function loadVendor() {
    if (vendorPromise) return vendorPromise;
    vendorPromise = new Promise((resolve, reject) => {
      let script = [...document.scripts].find(element => element.src === SCRIPT_URL);
      const timer = setTimeout(() => reject(new Error(ERRORS.network)), 15000);
      const loaded = () => {
        clearTimeout(timer);
        try { patchVendor(); resolve(); } catch (_) { reject(new Error(ERRORS.network)); }
      };
      if (typeof window.postData === 'function' && script) { loaded(); return; }
      const failed = () => { clearTimeout(timer); reject(new Error(ERRORS.network)); };
      if (!script) {
        script = document.createElement('script');
        script.src = SCRIPT_URL;
        script.async = true;
        script.id = 'MbgTbiVendorScript';
        script.addEventListener('load', loaded, { once: true });
        script.addEventListener('error', failed, { once: true });
        document.head.append(script);
      } else {
        script.addEventListener('load', loaded, { once: true });
        script.addEventListener('error', failed, { once: true });
      }
    });
    return vendorPromise;
  }

  async function launch(button, kind) {
    if (applicationPending) return;
    applicationPending = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    showError(button, '');
    let submissionSettled = true;
    let timedOut = false;
    try {
      await loadVendor();
      const items = kind === 'product' ? await productItems() : await currentCartItems(kind);
      const popup = document.getElementById('tbiPopUpContainer');
      const loading = document.getElementById('tbiLoading');
      const iframe = document.getElementById('tbiPopUpIframe');
      if (!popup || !loading || !iframe) fail('network');
      iframe.removeAttribute('src');
      popup.style.display = 'flex';
      loading.style.display = 'flex';
      let timer;
      submissionSettled = false;
      const submission = Promise.resolve().then(() => window.postData(BASKET_URL, { reseller_code: 'BGDW', reseller_key: 'multimediabg ', items }));
      const settled = () => {
        submissionSettled = true;
        if (timedOut) {
          popup.style.display = 'none';
          applicationPending = false;
          button.removeAttribute('aria-busy');
          scheduleRefresh();
        }
      };
      submission.then(settled, settled);
      try {
        await Promise.race([
          submission,
          new Promise((_, reject) => { timer = setTimeout(() => { timedOut = true; reject(new Error(ERRORS.network)); }, 30000); })
        ]);
      } finally { clearTimeout(timer); }
      const destination = iframe.getAttribute('src');
      if (!destination || !/^https:\/\//i.test(destination)) fail('network');
    } catch (error) {
      const popup = document.getElementById('tbiPopUpContainer');
      if (popup) popup.style.display = 'none';
      showError(button, Object.values(ERRORS).includes(error.message) ? error.message : ERRORS.network);
    } finally {
      applicationPending = !submissionSettled;
      if (submissionSettled) button.removeAttribute('aria-busy');
      scheduleRefresh();
    }
  }

  function installButton(anchor, kind, id) {
    if (!anchor?.parentElement) return null;
    const existing = anchor.parentElement.querySelector(`[data-mbg-tbi="${kind}"] .mbg-tbi-button`);
    if (existing) return existing;
    const wrapper = document.createElement('div');
    wrapper.className = 'mbg-tbi';
    wrapper.dataset.mbgTbi = kind;
    const button = document.createElement('button');
    button.type = 'button';
    button.id = id;
    button.className = 'mbg-tbi-button';
    button.append(document.createTextNode('Купи с '));
    const logo = document.createElement('img');
    logo.src = LOGO_URL;
    logo.alt = 'tbi bank';
    logo.className = 'tbiLogo';
    button.append(logo);
    const error = document.createElement('p');
    error.id = `${id}Error`;
    error.className = 'mbg-tbi-error';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    button.setAttribute('aria-describedby', error.id);
    button.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); launch(button, kind); });
    wrapper.append(button, error);
    anchor.after(wrapper);
    return button;
  }

  function installProduct() {
    const context = getMainProduct();
    if (!context || !context.form.querySelector('[name="add"]')) return;
    const button = installButton(context.form, 'product', 'tbiButton');
    if (button) button.disabled = applicationPending || productBusy(context.form);
    if (!sectionListeners.has(context.sectionId)) {
      const state = { variant: null };
      const listener = event => { state.variant = event.detail?.currentVariant || null; scheduleRefresh(); };
      state.listener = listener;
      ['maximize:variant-picker:updated:', 'maximize:color-swatch:change:'].forEach(prefix => document.addEventListener(prefix + context.sectionId, listener));
      sectionListeners.set(context.sectionId, state);
    }
  }

  function installCarts() {
    const cartActions = document.querySelector('#MainCart__Summary .main-cart__actions');
    const drawerActions = document.querySelector('#CartDrawer .cart-drawer__actions');
    if (cartActions?.querySelector('[name="checkout"]:not(:disabled)')) {
      const button = installButton(cartActions, 'cart', 'tbiCartButton');
      if (button) button.disabled = applicationPending;
    }
    if (drawerActions?.querySelector('[name="checkout"]:not(:disabled)')) {
      const button = installButton(drawerActions, 'drawer', 'tbiDrawerButton');
      if (button) button.disabled = applicationPending;
    }
  }

  function refresh() { installProduct(); installCarts(); }
  function scheduleRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    requestAnimationFrame(() => { refreshQueued = false; refresh(); });
  }

  function start() {
    refresh();
    loadVendor().catch(() => document.querySelectorAll('.mbg-tbi-button').forEach(button => showError(button, ERRORS.network)));
    const observer = new MutationObserver(records => {
      if (records.some(record => record.type === 'attributes' ? record.target.matches('button[name="add"]') : record.addedNodes.length || record.removedNodes.length)) scheduleRefresh();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    ['input', 'change', 'click'].forEach(type => document.addEventListener(type, event => {
      if (!(event.target instanceof Element) || event.target.closest('.mbg-tbi')) return;
      if (event.target.closest('#CartDrawer, .section-main-cart, #MainCart__Items, #MainCart__Summary')) {
        lastCartInteraction = Date.now();
        cartRevision++;
      }
    }, true));
    ['maximize:cart:updated', 'maximize:cart:item:fail-update', 'maximize:cart:discount-code:change', 'shopify:section:load'].forEach(type => document.addEventListener(type, () => { cartRevision++; scheduleRefresh(); }));
  }

  window.MbgTbiAdapter = { refresh: scheduleRefresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
